var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362.596,
    height: 295.591,
    viewBox: "0 0 362.596 295.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "developer",
    transform: "translate(4961.481 -7920.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M327.32,656.542a2.5,2.5,0,1,1-2.462-2.132A2.3,2.3,0,0,1,327.32,656.542Z",
    transform: "translate(-5112.053 7557.576)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M341.24,656.6a2.5,2.5,0,1,1-2.462-2.132A2.3,2.3,0,0,1,341.24,656.6Z",
    transform: "translate(-5118.324 7557.549)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M355.155,656.662a2.5,2.5,0,1,1-2.456-2.132A2.294,2.294,0,0,1,355.155,656.662Z",
    transform: "translate(-5124.594 7557.522)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(-4667.548 8074.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M606.746,403.989s-4.352-.313-3.951,9.451a113.085,113.085,0,0,0,1.4,14.957s-.126,2.165-1.8,1.742-4.83-2.522-6.369-.945-1.038,4.138,1.1,7.089,6.594,9.583,7,10.188.549,1.7-.638,1.588-9.21-2.824-10.27,1.061,6.253,11.122,7.039,11.924.83,1.319.511,1.808-2.929-.681-5.242-1.363-5.116-1.061-5.539,1.231,2.8,9,14.869,16.046l5.808,2.9,5.495-3.506c11.3-8.243,13.842-15.216,13.188-17.452s-3.4-1.577-5.633-.67-4.715,2.33-5.077,1.874-.379-.962.324-1.846,7.259-8.792,5.814-12.567-9.155-.253-10.325-.027-1.1-.9-.8-1.522,4.11-7.693,5.951-10.836,2.154-5.7.385-7.144-4.632,1-6.259,1.588-1.967-1.55-1.967-1.55a113.658,113.658,0,0,0-.11-15.023c-.577-9.754-4.99-9-4.99-9",
    transform: "translate(-589.945 -403.975)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M621.14,419.93a1.118,1.118,0,0,0,.027.2c.027.132,0,.346.044.6.039.55.088,1.313.154,2.308.138,2,.308,4.9.506,8.484.4,7.144.863,17.062,1.341,28.025s.918,20.843,1.275,28.025c.181,3.577.33,6.473.434,8.484.049.995.088,1.769.115,2.308v.6a1.986,1.986,0,0,1,0,.209v-.2c0-.132-.027-.346-.05-.6-.033-.549-.088-1.308-.154-2.3-.132-2-.3-4.9-.5-8.479-.4-7.144-.868-17.068-1.341-28.025s-.923-20.837-1.28-28.025c-.181-3.577-.33-6.473-.429-8.484-.049-.995-.088-1.769-.115-2.308a3.586,3.586,0,0,0-.028-.6Z",
    transform: "translate(-603.998 -411.163)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M608.77,455.55a1.879,1.879,0,0,1,.363.3c.225.2.549.506.923.885.764.758,1.8,1.835,2.913,3.044s2.077,2.275,2.841,3.11l.863.934a2.1,2.1,0,0,1,.3.363,1.86,1.86,0,0,1-.363-.3c-.225-.2-.55-.511-.918-.89-.758-.769-1.775-1.857-2.89-3.066l-2.863-3.088-.868-.934A2.2,2.2,0,0,1,608.77,455.55Z",
    transform: "translate(-598.425 -427.209)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M624.749,462.919c-.044-.044,2.083-2.269,4.742-4.946s4.858-4.852,4.9-4.814-2.077,2.269-4.742,4.946S624.793,462.963,624.749,462.919Z",
    transform: "translate(-605.623 -426.132)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M624.71,496.342a1.767,1.767,0,0,1,.4-.258l1.137-.637c.962-.549,2.28-1.286,3.709-2.165s2.7-1.709,3.61-2.324l1.1-.72a2.04,2.04,0,0,1,.418-.247,2.076,2.076,0,0,1-.363.313c-.242.192-.6.462-1.044.786-.9.643-2.154,1.506-3.588,2.379s-2.747,1.61-3.747,2.116c-.495.253-.89.451-1.171.577a2.523,2.523,0,0,1-.461.181Z",
    transform: "translate(-605.606 -442.724)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M607.2,490.83a2,2,0,0,1,.4.187c.253.137.61.335,1.049.588.885.5,2.1,1.209,3.434,2s2.533,1.522,3.4,2.061l1.016.643a.223.223,0,1,1-.044.077c-.247-.132-.61-.335-1.05-.588-.885-.5-2.1-1.209-3.434-2s-2.533-1.522-3.4-2.061l-1.017-.643A1.836,1.836,0,0,1,607.2,490.83Z",
    transform: "translate(-597.718 -443.103)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M603.72,517.86a2.873,2.873,0,0,1,.511.247l1.352.747c1.137.637,2.7,1.533,4.4,2.533s3.3,1.918,4.4,2.588l1.319.808a3.062,3.062,0,0,1,.467.319,2.139,2.139,0,0,1-.511-.247l-1.335-.742c-1.138-.637-2.7-1.533-4.4-2.533s-3.3-1.918-4.4-2.588l-1.319-.808A2.827,2.827,0,0,1,603.72,517.86Z",
    transform: "translate(-596.151 -455.279)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M625.93,523.683a2.525,2.525,0,0,1,.5-.341l1.412-.857c1.192-.725,2.835-1.737,4.616-2.9s3.4-2.269,4.5-3.055l1.357-.94a2.85,2.85,0,0,1,.516-.324,3.832,3.832,0,0,1-.461.4c-.308.242-.758.582-1.319,1-1.1.83-2.7,1.945-4.489,3.1s-3.44,2.154-4.654,2.846c-.61.346-1.1.621-1.451.8A3.826,3.826,0,0,1,625.93,523.683Z",
    transform: "translate(-606.156 -454.113)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M628.638,548.82H612.57l5.242,39.7H623.4Z",
    transform: "translate(-600.137 -469.228)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M614.09,556.372s0,.055.082.137a1.018,1.018,0,0,0,.39.28,1.945,1.945,0,0,0,1.7-.209,13.148,13.148,0,0,1,2.083-1.374,4.556,4.556,0,0,1,2.956.06,12.511,12.511,0,0,1,2.747,1.335,19.635,19.635,0,0,0,2.237,1.2,6.125,6.125,0,0,0,1.649.478,3.4,3.4,0,0,0,.467.033h.159a8.241,8.241,0,0,1-2.2-.665,21.227,21.227,0,0,1-2.2-1.236,12.162,12.162,0,0,0-2.8-1.374,4.72,4.72,0,0,0-3.121-.039,4.188,4.188,0,0,0-1.17.725,9.162,9.162,0,0,1-.923.714,1.907,1.907,0,0,1-1.566.275A1.652,1.652,0,0,1,614.09,556.372Z",
    transform: "translate(-600.822 -471.899)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M615.149,568.612s.132-.165.379-.423a3.549,3.549,0,0,1,1.286-.813,5.627,5.627,0,0,1,2.231-.341,23.54,23.54,0,0,1,2.8.385,9.6,9.6,0,0,0,2.863.115,7.608,7.608,0,0,0,2.253-.643,7.261,7.261,0,0,0,1.357-.8,1.943,1.943,0,0,0,.429-.39,13.568,13.568,0,0,1-1.857,1.022,8.173,8.173,0,0,1-2.2.577,9.955,9.955,0,0,1-2.791-.137,21.18,21.18,0,0,0-2.83-.368,5.731,5.731,0,0,0-2.313.407,3.3,3.3,0,0,0-1.286.918,2.542,2.542,0,0,0-.247.357A.455.455,0,0,0,615.149,568.612Z",
    transform: "translate(-601.299 -476.832)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M628.729,577.22a1.222,1.222,0,0,0-.445-.231,4.538,4.538,0,0,0-1.33-.286,8.15,8.15,0,0,0-2.011.115c-.753.121-1.555.324-2.4.506a10.158,10.158,0,0,1-2.39.269,5.143,5.143,0,0,1-1.9-.412,4.28,4.28,0,0,1-1.44-1.071,1.321,1.321,0,0,0,.275.423,3.346,3.346,0,0,0,1.1.819,5.073,5.073,0,0,0,1.967.484,9.712,9.712,0,0,0,2.456-.253c.857-.181,1.648-.4,2.385-.55a9.7,9.7,0,0,1,1.962-.17A7.089,7.089,0,0,1,628.729,577.22Z",
    transform: "translate(-602.047 -481.522)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M617.739,587.365a2.606,2.606,0,0,1,1.561-.154,7.421,7.421,0,0,1,1.648.61,6.246,6.246,0,0,0,2.1.566,6.379,6.379,0,0,0,3.846-.89,5.664,5.664,0,0,0,.956-.736c.192-.209.3-.33.28-.341a14.331,14.331,0,0,1-1.33.918,6.593,6.593,0,0,1-3.726.786c-1.522-.088-2.693-.995-3.748-1.1a2.357,2.357,0,0,0-1.209.1A.82.82,0,0,0,617.739,587.365Z",
    transform: "translate(-602.466 -486.166)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M619.37,600.18a3.106,3.106,0,0,0,1.335-.264c.808-.275,1.808-.89,2.978-1.357a4.947,4.947,0,0,1,1.709-.357,3.22,3.22,0,0,1,1.368.313,2.984,2.984,0,0,1,.995.857.719.719,0,0,0-.154-.335,2.115,2.115,0,0,0-.753-.681,3.072,3.072,0,0,0-1.456-.4,4.786,4.786,0,0,0-1.8.357c-1.209.484-2.2,1.1-2.951,1.423S619.365,600.141,619.37,600.18Z",
    transform: "translate(-603.201 -491.364)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M620.8,608.452a3.778,3.778,0,0,0,1.017.33,18.355,18.355,0,0,0,2.544.429,18.1,18.1,0,0,0,2.594.088,3.851,3.851,0,0,0,1.06-.126c0-.077-1.649,0-3.61-.209S620.822,608.375,620.8,608.452Z",
    transform: "translate(-603.845 -496.087)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M444.154,262.182,439,258",
    transform: "translate(-5164.59 7736.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M439,258a23.86,23.86,0,0,1,2.659,2.011,24.356,24.356,0,0,1,2.517,2.2,23.96,23.96,0,0,1-2.66-2.006A24.728,24.728,0,0,1,439,258Z",
    transform: "translate(-5164.59 7736.156)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M364,262.38a22.251,22.251,0,0,1,2.418-2.061,21.988,21.988,0,0,1,2.561-1.879,22.246,22.246,0,0,1-2.418,2.061A21.98,21.98,0,0,1,364,262.38Z",
    transform: "translate(-5130.802 7735.958)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(-4820.617 7920.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M430.011,206.91v44.385H366.264l-2.294-44.075Z",
    transform: "translate(-363.668 -206.91)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 43.977,
    height: 63.747,
    transform: "translate(0.301 44.287) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M427.921,251.5H363.57V206.92h64.351Zm-63.747-.6h63.144V207.524H364.174Z",
    transform: "translate(-363.57 -206.913)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 49.938,
    height: 33.051,
    transform: "translate(7.206 5.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M422.955,214.474H408.943l-35.949.075.144-.151v33.051h0l-.158-.158h49.938l-.128.128c0-10.059.053-18.306.068-24.049v-.083c0,5.765.038,14.035.068,24.147v.121H372.7V247.4h0V214.21h.143l36.046.075,10.255.038h3.637Z",
    transform: "translate(-365.81 -208.701)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M364,207.16a5.136,5.136,0,0,1,1.094.709c.656.475,1.509,1.139,2.5,1.909s1.8,1.509,2.4,2.037a5.144,5.144,0,0,1,.913.928,43.58,43.58,0,0,1-3.509-2.724A35.114,35.114,0,0,1,364,207.16Z",
    transform: "translate(-363.676 -206.971)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M446.2,207.32a30.821,30.821,0,0,1-3.358,2.86,29.2,29.2,0,0,1-3.547,2.6,31.629,31.629,0,0,1,3.35-2.852A31.305,31.305,0,0,1,446.2,207.32Z",
    transform: "translate(-382.155 -207.011)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 11.07,
    height: 31.421,
    transform: "translate(17.34 27.143) rotate(-90)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(-4713.267 7953.823)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 54.785,
    height: 90.679,
    transform: "translate(1.822)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 54.785,
    height: 90.679,
    transform: "translate(0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 50.118,
    height: 87.006,
    transform: "translate(2.333 1.844)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 30.817,
    height: 64.392,
    transform: "translate(11.875 13.143)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M502.33,290.51c-.072-6.014,5.337-11.883,11.293-12.726,2.837-.4,5.855.166,8.513-.922,4.739-1.945,6.244-8.239,11.012-10.083l.216,46.539H502.33Z",
    transform: "translate(-490.454 -235.762)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M360.1,347.02l30.97,17.15-1.165,2.187-30.69-17.474.885-1.863",
    transform: "translate(-5128.649 7696.054)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M358.06,342.286l1.423-2.176.83.506-1.275,2.2Z",
    transform: "translate(-5128.127 7699.167)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M405.83,373.29l1.594.918L402.236,407.3l-2.456.027Z",
    transform: "translate(-5146.922 7684.219)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M386.8,438.537s3.775-3.819,8.831-3.539a10.99,10.99,0,0,1,7.655,3.522Z",
    transform: "translate(-5141.073 7656.426)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M348.059,357.638,335.8,350.561l3.539-6.132a7.078,7.078,0,0,1,9.671-2.588h0a7.078,7.078,0,0,1,2.594,9.666Z",
    transform: "translate(-5118.099 7698.816)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 39.29,
    height: 1.912,
    transform: "translate(-4840.519 8093.342) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M216.346,415.858l7.369-27.618H193.036l-6.676,27.618Z",
    transform: "translate(-5050.776 7677.485)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M189.71,414.81h27.4l6.38-24.25H195.947Z",
    transform: "translate(-5052.285 7676.439)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 1.984,
    height: 94.735,
    transform: "translate(-4887.595 8099.002)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 1.984,
    height: 94.465,
    transform: "translate(-4885.611 8099.271)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 1.984,
    height: 94.735,
    transform: "translate(-4765.352 8099.002)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 1.984,
    height: 94.465,
    transform: "translate(-4763.368 8099.271)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 150.718,
    height: 7.77,
    transform: "translate(-4896.162 8093.496)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 66.353,
    height: 12.858,
    transform: "translate(-4830.709 8101.266)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M311.027,461.784a1.484,1.484,0,1,1-1.478-1.484A1.484,1.484,0,0,1,311.027,461.784Z",
    transform: "translate(-5105.602 7645.021)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M108.968,508.963h26.063a3.3,3.3,0,0,0,3.3-3.3V497.61A5.594,5.594,0,0,0,132.756,492H108.77Z",
    transform: "translate(-5015.823 7630.741)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M111.679,527.92H60.432a2.522,2.522,0,0,1-2.522-2.528h0a2.517,2.517,0,0,1,2.522-2.522h51.247a2.522,2.522,0,0,1,2.528,2.522h0a2.528,2.528,0,0,1-2.528,2.528Z",
    transform: "translate(-4992.91 7616.834)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M38.043,400.02l28.19-.5,17.9,67.633-38.169.385L31.576,408.246a6.654,6.654,0,0,1,6.468-8.226Z",
    transform: "translate(-4980.962 7672.403)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M62.135,532.06,53.7,581.081h2.313L67.1,532.06Z",
    transform: "translate(-4991.014 7612.694)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M97.892,532.06,88.93,581.081h2.313L102.86,532.06Z",
    transform: "translate(-5006.885 7612.694)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M141.2,532.06l10,49.021h-2.313L136.23,532.06Z",
    transform: "translate(-5028.193 7612.694)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M88.93,399.52l13.952,67.7h10.7L102.393,407.4a9.638,9.638,0,0,0-9.473-7.88Z",
    transform: "translate(-5006.885 7672.403)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(-4929.208 7965.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 1.807,
    height: 16.17,
    transform: "translate(6.672 55.178)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 1.807,
    height: 16.17,
    transform: "translate(66.237 55.178)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 75.75,
    height: 6.505,
    transform: "translate(0 48.674)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 10.444,
    height: 48.674,
    transform: "translate(50.345)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M117.049,258.959a2.069,2.069,0,1,1-2.069-2.07A2.069,2.069,0,0,1,117.049,258.959Z",
    transform: "translate(-59.206 -221.964)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 3.194,
    height: 19.895,
    transform: "translate(54.083 12.892)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 10.444,
    height: 48.674,
    transform: "translate(39.735)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M101.669,258.959a2.069,2.069,0,1,1-2.069-2.07A2.069,2.069,0,0,1,101.669,258.959Z",
    transform: "translate(-54.436 -221.964)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 3.194,
    height: 19.895,
    transform: "translate(43.48 12.892)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 10.444,
    height: 48.674,
    transform: "translate(29.628)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M87.019,258.959a2.069,2.069,0,1,1-2.069-2.07A2.069,2.069,0,0,1,87.019,258.959Z",
    transform: "translate(-49.892 -221.964)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 3.194,
    height: 19.895,
    transform: "translate(33.374 12.892)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M57.2,255.641l12.548-42.817-4.325-1.9L52.55,254.089Z",
    transform: "translate(-40.484 -207.705)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M372.316,620.943c0,.077-81.178.143-181.293.143s-181.3-.066-181.3-.143,81.156-.143,181.3-.143S372.316,620.86,372.316,620.943Z",
    transform: "translate(-4971.201 7572.717)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(-4958.97 8097.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(35.044 22.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M81.347,515.258c5.006,1.747,11.54.187,15.815-2.94s7.363-7.605,10.094-12.15a18.059,18.059,0,0,0,2.671-6.193,6.7,6.7,0,0,0-1.907-6.2c-2.687-2.264-6.808-1.1-9.891.626a34.069,34.069,0,0,0-16.809,26.86",
    transform: "translate(-71.666 -486.517)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M96.2,494.29a1.026,1.026,0,0,1-.121.11l-.379.3-1.484,1.1-1.1.8c-.385.3-.791.643-1.231,1-.874.731-1.907,1.517-2.951,2.506l-1.649,1.517c-.549.549-1.132,1.127-1.731,1.714-1.214,1.171-2.39,2.533-3.66,3.945a77.886,77.886,0,0,0-12.908,20.881c-.7,1.764-1.39,3.429-1.89,5.039-.264.8-.55,1.561-.764,2.313s-.418,1.478-.61,2.171c-.423,1.368-.659,2.649-.923,3.753-.126.549-.253,1.071-.346,1.55s-.159.918-.231,1.319c-.137.769-.247,1.374-.33,1.819-.038.192-.066.346-.093.473a.6.6,0,0,1-.044.159.742.742,0,0,1,0-.165c0-.126.038-.286.06-.478.066-.445.154-1.055.269-1.83l.2-1.324c.088-.484.209-1,.324-1.561.242-1.1.467-2.4.874-3.781q.291-1.039.593-2.2c.209-.758.489-1.528.747-2.33.495-1.648,1.181-3.3,1.868-5.066a76.075,76.075,0,0,1,12.963-20.975c1.28-1.407,2.467-2.747,3.7-3.934.6-.588,1.165-1.187,1.747-1.709l1.687-1.506c1.055-.978,2.1-1.758,2.989-2.473.445-.357.857-.692,1.247-.984l1.1-.775,1.522-1.055.4-.269A.551.551,0,0,1,96.2,494.29Z",
    transform: "translate(-63.752 -490.019)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M105.8,519.584c0,.049-.857.049-2.231.126a41.888,41.888,0,0,0-5.336.648,41.089,41.089,0,0,0-5.2,1.352c-1.308.434-2.1.747-2.121.7a2.1,2.1,0,0,1,.549-.286c.352-.17.868-.385,1.517-.632a32.073,32.073,0,0,1,5.215-1.462,31.614,31.614,0,0,1,5.385-.549h1.649A2.2,2.2,0,0,1,105.8,519.584Z",
    transform: "translate(-75.986 -501.367)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(35.362 55.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M91.15,554.092c3.006,3.967,8.171,5.731,13.139,5.962s9.891-1.149,14.529-2.929c1.687-.648,3.533-1.533,4.11-3.242a4.127,4.127,0,0,0-.879-3.846,8.584,8.584,0,0,0-3.357-2.291,22.93,22.93,0,0,0-14.622-.791c-4.814,1.247-9.012,4.039-12.919,7.144",
    transform: "translate(-76.412 -546.129)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M105.818,553.861a2.561,2.561,0,0,1-.484-.082c-.319-.055-.775-.176-1.379-.275a37.46,37.46,0,0,0-35.41,11.979,38.466,38.466,0,0,0-3.16,4.072c-.352.495-.588.907-.769,1.17a2.978,2.978,0,0,1-.286.4,2.457,2.457,0,0,1,.225-.434c.165-.28.385-.7.72-1.209a34.438,34.438,0,0,1,3.094-4.154,36.713,36.713,0,0,1,30.492-12.688,35.258,35.258,0,0,1,5.127.731c.6.121,1.055.264,1.368.341A3.121,3.121,0,0,1,105.818,553.861Z",
    transform: "translate(-64.33 -549.019)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M121.946,560.756a20.771,20.771,0,0,0-2.912-4.4,21.592,21.592,0,0,0-4.154-3.22,4.824,4.824,0,0,1,1.434.632,12.71,12.71,0,0,1,5.1,5.495A5.166,5.166,0,0,1,121.946,560.756Z",
    transform: "translate(-87.102 -549.288)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(35.06 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M79.552,475.3c4.143.082,7.281-3.544,9.155-7.242a26.832,26.832,0,0,0,2.467-16.738c-.379-2.116-1.181-4.4-3.072-5.418s-4.435-.352-6.045,1.1a12.379,12.379,0,0,0-3.143,5.665,38.081,38.081,0,0,0,.643,22.612",
    transform: "translate(-69.958 -445.405)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M79.48,455a.6.6,0,0,1,0,.187l-.11.55c-.115.494-.269,1.187-.467,2.072-.407,1.8-1.028,4.4-1.808,7.589-1.555,6.4-3.814,15.21-6.171,24.975-1.17,4.885-2.231,9.556-3.143,13.809S66.1,512.3,65.55,515.539c-.308,1.615-.55,3.088-.753,4.4s-.39,2.4-.55,3.3-.247,1.594-.324,2.1c-.038.22-.066.4-.093.549a.715.715,0,0,1-.044.181.956.956,0,0,1,0-.187c0-.143.038-.324.06-.549.066-.506.154-1.209.264-2.1s.264-2.028.473-3.3.412-2.748.7-4.4c.55-3.253,1.28-7.1,2.16-11.369s1.951-8.935,3.121-13.826c2.357-9.77,4.654-18.573,6.27-24.958l1.9-7.589.55-2.055c.06-.22.1-.4.143-.549A.775.775,0,0,1,79.48,455Z",
    transform: "translate(-63.782 -449.728)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M90.43,472.8c.071.071-1.231,1.363-2.649,3.11s-2.429,3.3-2.511,3.22a19.894,19.894,0,0,1,5.16-6.33Z",
    transform: "translate(-73.462 -457.747)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M86.877,459.39a12.474,12.474,0,0,1,.643,2.786,12.216,12.216,0,0,1,.313,2.846,24.56,24.56,0,0,1-.956-5.632Z",
    transform: "translate(-74.173 -451.705)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(24.326 7.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M50.964,504.761c7.067-12.023,8.243-26.733,4.072-40.037-.676-2.16-1.956-4.627-4.215-4.77-2.5-.159-4.066,2.627-4.753,5.033-2.423,8.451-1.907,17.425-1.374,26.2.33,5.4,2.2,10.023,6.27,13.573",
    transform: "translate(-44.248 -459.948)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M58.848,534.746a.5.5,0,0,1-.044-.143l-.1-.434c-.082-.412-.2-.967-.346-1.649-.3-1.451-.7-3.566-1.148-6.182-.907-5.231-1.978-12.5-2.643-20.573-.319-4.039-.495-7.9-.55-11.408s-.027-6.676.082-9.342c.033-1.324.121-2.522.181-3.577s.126-1.956.2-2.7.115-1.286.154-1.7a3.792,3.792,0,0,1,.049-.44.4.4,0,0,0,0-.148.385.385,0,0,1,0,.148v.445c0,.418-.055.989-.093,1.709s-.1,1.649-.137,2.7-.115,2.247-.132,3.577c-.077,2.649-.082,5.808,0,9.342s.286,7.352.6,11.386c.659,8.067,1.692,15.326,2.539,20.562.423,2.621.786,4.737,1.044,6.2.121.709.214,1.269.286,1.682l.066.439a.406.406,0,0,1-.011.11Z",
    transform: "translate(-48.637 -467.382)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M59.215,501.479a35.736,35.736,0,0,1-2.066,4.352,35.438,35.438,0,0,1-2.368,4.176,35.451,35.451,0,0,1,2.072-4.352A34.619,34.619,0,0,1,59.215,501.479Z",
    transform: "translate(-48.993 -478.657)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M48.534,487.189a19.552,19.552,0,0,1,1.747,3.149,19.682,19.682,0,0,1,1.456,3.3,19.385,19.385,0,0,1-1.753-3.143A19.3,19.3,0,0,1,48.534,487.189Z",
    transform: "translate(-46.176 -472.219)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(0 38.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M23.674,535.077A28.882,28.882,0,0,0,6.535,516.9c-1.874-.7-4.259-1.1-5.66.324s-.951,3.764-.071,5.5a27.484,27.484,0,0,0,6.045,7.309,25.03,25.03,0,0,0,6.913,5.149c2.649,1.159,7.506,1.451,9.924-.126",
    transform: "translate(0.022 -516.263)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M40.426,558.272a2.258,2.258,0,0,1-.181-.418l-.467-1.209-.33-.874-.456-1.017-.517-1.165c-.181-.418-.418-.83-.643-1.28l-.72-1.4c-.275-.478-.549-.967-.863-1.478-.549-1.039-1.3-2.066-2.006-3.187a76.728,76.728,0,0,0-5.319-6.8,84.2,84.2,0,0,0-6.111-6.11c-1.011-.857-1.94-1.715-2.879-2.429l-1.341-1.066-1.269-.94c-.8-.6-1.555-1.1-2.2-1.561a18.085,18.085,0,0,0-1.714-1.1l-1.1-.692a2.278,2.278,0,0,1-.374-.264,2.363,2.363,0,0,1,.407.2l1.126.643a18.541,18.541,0,0,1,1.747,1.1c.648.462,1.44.929,2.253,1.528l1.286.918,1.357,1.055c.951.714,1.89,1.566,2.918,2.418a80.479,80.479,0,0,1,6.138,6.078,72.544,72.544,0,0,1,5.33,6.847c.7,1.137,1.434,2.2,1.995,3.226l.846,1.495.7,1.418c.22.451.451.874.626,1.3l.495,1.182.434,1.033.3.885c.17.511.308.923.407,1.236a1.931,1.931,0,0,1,.115.434Z",
    transform: "translate(-5.367 -520.325)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M22.288,535.51c0,.093-1.423-.176-3.176-.3s-3.171-.055-3.182-.154a8.837,8.837,0,0,1,3.209-.181A9.218,9.218,0,0,1,22.288,535.51Z",
    transform: "translate(-7.165 -524.631)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M41.87,579.27l3.918,20.678a2.9,2.9,0,0,0,2.846,2.357H60.267a2.89,2.89,0,0,0,2.857-2.423l3.418-20.612Z",
    transform: "translate(-18.85 -505.711)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M43.145,585.99H65.361l1.181-6.721H41.87Z",
    transform: "translate(-18.85 -505.711)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M44.19,591.5l.467,2.451H66.066l.341-2.451Z",
    transform: "translate(-19.895 -511.22)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M332.2,337.694c0,.879,1.506,1.594,3.363,1.594s3.363-.714,3.363-1.594-1.506-1.594-3.363-1.594S332.2,336.787,332.2,337.694Z",
    transform: "translate(-5116.477 7700.974)",
    fill: "#fea086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M246.194,514.609s-61.149,2.2-63.66,12.232,103.1,38.57,133.178,27.206,38.147-18.4,38.147-18.4,2.258-11.479-46.021-17.584S246.194,514.609,246.194,514.609Z",
    transform: "translate(-5049.033 7620.813)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M327.071,285.336c-5.121.154-9.413,4.27-11.171,8.968-2.791,7.435-.934,24.634,5.572,26.959s13.946,2.2,16.732-3.792c4.2-9.006,3.3-30.267-9.446-32.047A10.335,10.335,0,0,0,327.071,285.336Z",
    transform: "translate(-5108.567 7723.844)",
    fill: "#fea086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M311.952,474.721s34-11.117,36.619-19.661-9.809-69.238-16.348-75.15c-6.33-5.7-40.4-10.787-42.548-11.1h-.1c-2.149.313-36.218,5.4-42.548,11.1-6.539,5.885-18.963,66.611-16.32,75.15s36.619,19.661,36.619,19.661l3.3-8.177-24.03-19.277s10.094-33.36,13.463-25.513,9.891,34.333,9.891,34.333h39.394s6.539-26.486,9.891-34.333S332.8,447.268,332.8,447.268l-22.486,19.694Z",
    transform: "translate(-5070.588 7686.237)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M266.618,530.993h67.023l13.078-37.273H253.54Z",
    transform: "translate(-5081.041 7629.966)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M339.261,359.263V343.52H328.87v15.743S334.173,364.308,339.261,359.263Z",
    transform: "translate(-5114.977 7697.63)",
    fill: "#fea086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M338.564,302.239a109.681,109.681,0,0,0,5.638-13.188c1.956-5.435-1.714-6.369-3.434-9.254s-1.962-2.121.736-4.171,2.2-5.006-2.94-6.83-7.605,1.368-15.386,2.28-3.259-1.368-9.633.681-8.825,8.649-8.825,14.793,1.72,7.913,2.451,13.188a10.781,10.781,0,0,0,1.3,3.847c-1.011,9.408,1.61,19.854,5.072,19.92,4.4.082,5.885-2.533,9.528,0s15.974-1.066,12.9-6.215c-1.731-2.907-.291-8.309.6-12.056A22.423,22.423,0,0,0,338.564,302.239Zm-10.182,2.039c-6.149-1.473-9.924.736-12.869,2.11-1.308.61-2.506-1.319-3.429-3.649a34.613,34.613,0,0,1,.978-8.292c1.473-5.286,4.4-4.72,11.682-4.946s7.693-4.511,8.666,1.594a112.33,112.33,0,0,1,1,11.512C332.761,304.278,333.393,305.476,328.382,304.278Z",
    transform: "translate(-5104.098 7731.542)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M185.733,532.948a11.9,11.9,0,0,0-5.643,2.2c-5.319,4.347-2.808,11.842,1.28,17.617a30.777,30.777,0,0,0,5.594,6.044c7.49,5.968,17.969,8.951,27.9,10.891,11.292,2.2,22.969,2.995,34.542,3.368,3.451.11,25.277,2.2,27.1.2l5.682-6.325c.137-.154-30.8-15.2-32.751-16.067C232.612,543.422,205.686,529.7,185.733,532.948Z",
    transform: "translate(-5046.59 7612.515)",
    fill: "#150958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M376.922,600.648,373.74,599l-2.5,7.984c4.4,2.934,26.711,8.759,25.041.868S376.922,600.648,376.922,600.648Z",
    transform: "translate(-5134.064 7582.537)",
    fill: "#175db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M399.689,539.668c-19.947-3.253-46.873,10.474-63.7,17.941-1.951.868-32.888,15.936-32.75,16.067l5.682,6.33c1.808,2.017,23.629-.093,27.1-.2,11.6-.368,23.25-1.16,34.542-3.357,9.93-1.934,20.409-4.946,27.9-10.891a30.433,30.433,0,0,0,5.594-6.045c4.088-5.775,6.594-13.27,1.286-17.617A11.7,11.7,0,0,0,399.689,539.668Z",
    transform: "translate(-5103.43 7609.487)",
    fill: "#150958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M267.929,607.825c-1.649,7.891,20.667,2.066,25.041-.868L290.459,599l-3.182,1.648S269.6,599.934,267.929,607.825Z",
    transform: "translate(-5087.483 7582.537)",
    fill: "#175db8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.52c40f2147841c028dc1ca6e9f244ad7.svg";
export { ForwardRef as ReactComponent };